import { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import { useToast } from "../context/ToastContext";
import { UserContext } from "../context/UserContext";
import { consumeRedirectAfterLogin } from "../utils/redirectAfterLogin";

import Button from "./Button";
import FormInput from "./FormInput";

import "../assets/styles/checkout.css";
import "../assets/styles/pages.css";

const Login = ({ inModal = false }) => {
  const navigate = useNavigate();
  const { login, isAuthenticated, loadingAuth } = useContext(UserContext);
  const { toast } = useToast();

  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const disabled = submitting || !email.trim() || !pass.trim();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (disabled) return;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.trim())) {
      const msg = "Por favor, informe um e-mail válido.";
      setError(msg);
      if (!inModal) {
        toast.error(msg);
      }
      return;
    }

    setSubmitting(true);
    setError("");
    try {
      await login(email, pass);
      if (inModal) return;
      const redirect = consumeRedirectAfterLogin("/minha-conta");
      navigate(redirect, { replace: true });
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.data?.message ||
        err?.message ||
        "E-mail ou senha incorretos.";
      setError(msg);
      if (!inModal) {
        toast.error(msg);
      }
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (!inModal && isAuthenticated && !loadingAuth) {
      const redirect = consumeRedirectAfterLogin("/minha-conta");
      navigate(redirect, { replace: true });
    }
  }, [isAuthenticated, loadingAuth, navigate, inModal]);

  const formContent = (
    <div>
      <h2 className="mb-4">
        <strong>Entre na sua conta</strong>
      </h2>
      <div>
        <form onSubmit={handleLogin}>
          <FormInput
            type="email"
            name="email"
            label="E-mail"
            placeholder="Informe seu e-mail"
            float
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={submitting}
          />
          <FormInput
            type="password"
            name="senha"
            label="Senha"
            placeholder="Informe sua senha"
            float
            value={pass}
            onChange={(e) => setPass(e.target.value)}
            disabled={submitting}
          />
          {error && (
            <div
              className="alert alert-danger text-center mt-3 mb-0"
              role="alert"
              style={{ fontSize: "14px", padding: "10px" }}
            >
              {error}
            </div>
          )}
          <Button
            classes="mt-3"
            type="submit"
            label={submitting ? "Entrando..." : "FAZER LOGIN"}
            disabled={disabled}
          />
          {!inModal && (
            <div className="text-center mt-3">
              <Link to="/recuperar" className="btn btn-link">
                Esqueceu sua senha?
              </Link>
            </div>
          )}
        </form>
      </div>
    </div>
  );

  if (inModal) {
    return formContent;
  }

  return (
    <div className="Checkout">
      <Helmet>
        <title>Login</title>
        <meta
          name="description"
          content="Para realizar o processo de personalização, basta preencher nossa anamnese - 100% online - criada por nossa equipe médica-nutricionista-farmacêutica."
        />
      </Helmet>

      <section className="Login">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">{formContent}</div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Login;
